// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orcamentos_SalvarOrcamentoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /orcamentos/salvar_orcamento
 *
 * Validates orcamento creation with nested Cliente and Servicos.
 */
import type { OrcamentoClienteInputRow } from './OrcamentoClienteInputRow'
import type { OrcamentoDataInputRow } from './OrcamentoDataInputRow'
import type { OrcamentoServicoInputRow } from './OrcamentoServicoInputRow'
import { registerContract } from './validate'

export interface Orcamentos_SalvarOrcamentoInput {
Cliente: OrcamentoClienteInputRow
Orcamento: OrcamentoDataInputRow
Servicos: OrcamentoServicoInputRow[]
}

registerContract('Orcamentos_SalvarOrcamentoInput', {
  Cliente: {
    type: 'object',
    required: true,
    fields: {
      cliente_nome:          { type: 'string',  required: true },
      cliente_telefone:      { type: 'string',  required: true },
      cliente_id:            { type: 'number',  required: false },
      cliente_cpf:           { type: 'string',  required: false },
      cliente_document_type: { type: 'string',  required: false },
      cliente_ddi:           { type: 'string',  required: false },
      cliente_ddd:           { type: 'string',  required: false },
      cliente_rua:           { type: 'string',  required: false },
      cliente_numero:        { type: 'string',  required: false },
      cliente_complemento:   { type: 'string',  required: false },
      cliente_bairro:        { type: 'string',  required: false },
      cliente_cep:           { type: 'string',  required: false },
      cliente_location_id:   { type: 'number',  required: false },
      cliente_location_type: { type: 'string',  required: false },
      cliente_franquia_id:   { type: 'number',  required: false },
      cliente_status:        { type: 'number',  required: false },
    },
  },
  Orcamento: {
    type: 'object',
    required: true,
    fields: {
      orcamento_franquia_id:   { type: 'number',  required: true },
      orcamento_user_id:       { type: 'string',  required: false },
      orcamento_location_id:   { type: 'number',  required: false },
      orcamento_location_type: { type: 'string',  required: false },
      orcamento_valor:         { type: 'number',  required: false },
      orcamento_origem:        { type: 'number',  required: false },
      orcamento_data:          { type: 'string',  required: false },
      orcamento_status:        { type: 'string',  required: false },
      orcamento_observacao:    { type: 'string',  required: false },
      orcamento_cliente_id:    { type: 'number',  required: false },
    },
  },
  Servicos: {
    type: 'array',
    required: true,
    items: {
      servico_id:     { type: 'number',  required: true },
      valor:          { type: 'number',  required: true },
      qtd:            { type: 'number',  required: true },
      categoria_id:   { type: 'number',  required: false },
      categoria_nome: { type: 'string',  required: false },
      uuid:           { type: 'string',  required: false },
    },
  },
})
